import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-38316c2a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "property-detail-accordion" }
const _hoisted_2 = {
  key: 0,
  class: "specialisms_multiselect_modal_body"
}
const _hoisted_3 = { class: "specialisms_multiselect_modal_inner no-scrollbar" }
const _hoisted_4 = { class: "specialisms_multiselect_modal_item_heading" }
const _hoisted_5 = { class: "specialisms_multiselect_modal_item_title" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "specialisms_multiselect_modal_item_title_text" }
const _hoisted_8 = { key: 0 }

import { computed, onMounted, ref, watch } from "vue";
import { useStore } from "vuex";
import { USER_STORE } from "@/store/modules/user";
import { PROJECT_STORE } from "@/store/modules/project";
import CommonLoader from "@/core/components/CommonLoader.vue";
import { ProjectSpecialismGeneratedEnum } from "@/core/enums/ProjectsEnum";
import { WORKSTATION } from "@/store/modules/workstation";
import { debounce } from "lodash";


export default /*#__PURE__*/_defineComponent({
  __name: 'PropertySpecialismDropDownModal',
  props: {
  isReview: {
    type: Boolean,
    default: false,
  },
},
  emits: ["onClickCloseTab", "onClickSaveSpecialism"],
  setup(__props, { emit: __emit }) {

const store = useStore();
const selectedCategory = ref([]) as any;
const props = __props;
const emit = __emit;
const mainCategory = ref([]) as any;
const panel = ref([]) as any;
const listOfSpecialismsCategory = computed(
  () => store.getters[`${USER_STORE}/specialismsCategory`]
);
const subCategoryList = computed(() =>
  listOfSpecialismsCategory.value.flatMap(
    (category: any) => category.subCategories
  )
);
const isLoading = ref(false);
const user = computed(() => store.getters[`${USER_STORE}/user`]);
const projectSpecialisms = computed(
  () => store.getters[`${PROJECT_STORE}/projectSpecialisms`]
);
const activeUserWorkstation = computed(
  () => store.getters[`${WORKSTATION}/activeUserWorkstation`]
);
const onClickMainCategory = (mainCategoryId: number) => {
  if (mainCategory.value.includes(mainCategoryId)) {
    const mainCategory = listOfSpecialismsCategory.value.find(
      (category: any) => category?.id === mainCategoryId
    );
    mainCategory.subCategories.forEach((element: any) => {
      const elementIndex = selectedCategory.value.findIndex(
        (subCategory: any) => subCategory === element.id
      );
      if (elementIndex > -1) {
        selectedCategory.value.splice(elementIndex, 1);
      }
    });
  } else {
    const mainCategory = listOfSpecialismsCategory.value.find(
      (category: any) => category?.id === mainCategoryId
    );

    mainCategory.subCategories.forEach((element: any) => {
      if (!selectedCategory.value.includes(element?.id)) {
        selectedCategory.value.push(element?.id);
      }
    });
  }
};

onMounted(async () => {
  try {
    if (!listOfSpecialismsCategory.value) {
      isLoading.value = true;
      await store.dispatch(`${USER_STORE}/getCategories`);
    }
    if (!getAllSpecialism.value.length) {
      await store.dispatch(
        `${USER_STORE}/setAllSpecialismsCategory`,
        activeUserWorkstation.value.id
      );
    }

    projectSpecialisms.value.forEach((specialism: any) => {
      selectedCategory.value.push(specialism.id);
    });
    listOfSpecialismsCategory.value.forEach(
      (specialism: any, index: number) => {
        if (specialism.subCategories.length) {
          const isSelectedAllSubCategory = specialism.subCategories.every(
            (subCategory: any) =>
              selectedCategory.value.includes(subCategory.id)
          );
          if (isSelectedAllSubCategory) {
            mainCategory.value.push(specialism.id);
            panel.value.push(index);
          }
        }
      }
    );
  } catch (error) {
    console.log();
  } finally {
    isLoading.value = false;
  }
});
const getAllSpecialism = computed(
  () => store.getters[`${USER_STORE}/getAllSpecialism`]
);
const onclickSaveButton = async () => {
  try {
    if (!props.isReview) {
      const newAddedSubCategoriesData = await store.dispatch(
        `${PROJECT_STORE}/getNewAddedSubCategoryForProject`,
        {
          subCategoriesIds: selectedCategory.value,
          generatedBySpecialism: ProjectSpecialismGeneratedEnum.PROPERTY,
        }
      );
      // const newAddedSubCategoriesData = subCategoryList.value
      //   .filter((subCategory: any) =>
      //     selectedCategory.value.includes(subCategory?.id)
      //   )
      //   .map((subCategory: any) => ({
      //     ...subCategory,
      //     generatedBy: ProjectSpecialismGeneratedEnum.PROPERTY,
      //   }));
      store.dispatch(
        `${PROJECT_STORE}/setProjectSpecialisms`,
        newAddedSubCategoriesData
      );
    } else {
      emit("onClickSaveSpecialism", selectedCategory.value);
    }
  } catch (error) {
    console.log();
  } finally {
    onCloseModal();
  }
};
watch(
  () => selectedCategory.value,
  debounce(async () => {
    console.log("aaa");
    await onclickSaveButton();
  }, 350),
  { immediate: true, deep: true }
);
const onCloseModal = () => {
  return emit("onClickCloseTab");
};

return (_ctx: any,_cache: any) => {
  const _component_v_expansion_panel_title = _resolveComponent("v-expansion-panel-title")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_expansion_panel_text = _resolveComponent("v-expansion-panel-text")!
  const _component_v_expansion_panel = _resolveComponent("v-expansion-panel")!
  const _component_v_expansion_panels = _resolveComponent("v-expansion-panels")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!isLoading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_v_expansion_panels, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_expansion_panel, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_expansion_panel_title, null, {
                    default: _withCtx(() => [
                      _createTextVNode("Select Service ")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_expansion_panel_text, null, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_3, [
                        _createVNode(_component_v_expansion_panels, {
                          modelValue: panel.value,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((panel).value = $event)),
                          multiple: ""
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(listOfSpecialismsCategory.value, (specialism, index) => {
                              return (_openBlock(), _createBlock(_component_v_expansion_panel, { key: index }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_expansion_panel_title, null, {
                                    default: _withCtx(() => [
                                      _createElementVNode("div", _hoisted_4, [
                                        _createVNode(_component_v_checkbox, {
                                          color: "#4B4BFF",
                                          value: specialism.id,
                                          modelValue: mainCategory.value,
                                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((mainCategory).value = $event)),
                                          onClick: ($event: any) => (onClickMainCategory(specialism.id))
                                        }, null, 8, ["value", "modelValue", "onClick"]),
                                        _createElementVNode("div", _hoisted_5, [
                                          (specialism.iconName)
                                            ? (_openBlock(), _createBlock(_component_v_icon, {
                                                key: 0,
                                                class: "specialisms_multiselect_modal_item_title_icon"
                                              }, {
                                                default: _withCtx(() => [
                                                  (specialism.iconName)
                                                    ? (_openBlock(), _createElementBlock("img", {
                                                        key: 0,
                                                        style: {"width":"14px"},
                                                        src: 
                              require('@/assets/category-icons/' +
                                specialism.iconName +
                                '.svg')
                            ,
                                                        alt: "icon"
                                                      }, null, 8, _hoisted_6))
                                                    : _createCommentVNode("", true)
                                                ]),
                                                _: 2
                                              }, 1024))
                                            : _createCommentVNode("", true),
                                          _createElementVNode("div", _hoisted_7, [
                                            _createElementVNode("h2", null, _toDisplayString(specialism?.poLabel), 1),
                                            _createElementVNode("p", null, [
                                              _createTextVNode(_toDisplayString(specialism.subCategories
                                .slice(0, 2)
                                .map((sub) => sub.label)
                                .join(", ")) + " ", 1),
                                              (specialism.subCategories?.length > 2)
                                                ? (_openBlock(), _createElementBlock("span", _hoisted_8, " etc.."))
                                                : _createCommentVNode("", true)
                                            ])
                                          ])
                                        ])
                                      ])
                                    ]),
                                    _: 2
                                  }, 1024),
                                  _createVNode(_component_v_expansion_panel_text, null, {
                                    default: _withCtx(() => [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(specialism.subCategories, (subCategories) => {
                                        return (_openBlock(), _createElementBlock("div", {
                                          class: "specialisms_multiselect_modal_item_content",
                                          key: subCategories.id
                                        }, [
                                          _createVNode(_component_v_checkbox, {
                                            color: "#4B4BFF",
                                            label: subCategories.label,
                                            value: subCategories.id,
                                            modelValue: selectedCategory.value,
                                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((selectedCategory).value = $event))
                                          }, null, 8, ["label", "value", "modelValue"])
                                        ]))
                                      }), 128))
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1024))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true),
    _createVNode(CommonLoader, {
      loading: isLoading.value,
      class: "loader-container"
    }, null, 8, ["loading"])
  ]))
}
}

})